import { render } from "./Home.vue?vue&type=template&id=b8b1fea2&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=b8b1fea2&lang=scss&scoped=true"

import exportComponent from "/data/sg-h5/panther-h5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8b1fea2"]])

export default __exports__